import React from 'react';
import styled from 'styled-components/macro';
import { useMessageGetter } from 'react-message-context';
import { theme } from '../../../theme';
import { infoFilledIcon } from '../../../assets';
import { notificationColors } from '../../../components/Notifications';
import { Body2, Body3 } from '../../../components/common';
import { NotificationType } from '../../../context/appContext';
import { KennoTerminationDisallowedReason } from '../../../context/kennoTenantContext';

const NotificationContainer = styled.div<{ type: NotificationType }>`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 2rem 3rem 2rem;
  background-color: ${({ type }) => notificationColors[type]};
  padding: 16px 24px;
  border-radius: 16px;
  border: 1px solid ${theme().colors.m2Black};
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 15px;
`;

export const getTerminationNotificationType = (
  kennoTerminationDisallowedReason?: KennoTerminationDisallowedReason
): NotificationType | undefined => {
  switch (kennoTerminationDisallowedReason) {
    case KennoTerminationDisallowedReason.PENDING_TERMINATION_TENANT_APPROVALS:
      return NotificationType.INFO;
    case KennoTerminationDisallowedReason.PENDING_TERMINATION_REVIEW:
      return NotificationType.SUCCESS;
    case undefined:
      return;
    default:
      return NotificationType.ERROR;
  }
};

interface Props {
  kennoTerminationDisallowedReason?: KennoTerminationDisallowedReason;
}

const TerminationDisallowedNotification: React.FC<Props> = ({ kennoTerminationDisallowedReason }) => {
  const translationPrefix = 'termination.kenno_termination_disallowed_reason';
  const t = useMessageGetter(translationPrefix);
  const message = t(kennoTerminationDisallowedReason) || t('general');
  const notificationType = getTerminationNotificationType(kennoTerminationDisallowedReason);

  return (
    <NotificationContainer type={notificationType}>
      <MessageContainer>
        <img src={infoFilledIcon} alt="" />
        <Body2 margin={'0'}>{message}</Body2>
      </MessageContainer>
      {notificationType === NotificationType.ERROR && <Body3> {t('help')}</Body3>}
    </NotificationContainer>
  );
};

export default TerminationDisallowedNotification;
